export default function isElementVisibleInScrollContainer(element: HTMLElement, container: HTMLElement, options: {
    minVisiblePercent?: number,
    considerPartial?: boolean
} = {}) {
    const {
        minVisiblePercent = 0.00001, // минимальный процент видимости (0-100)
        considerPartial = true  // учитывать частичную видимость
    } = options;

    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();

    // Рассчитываем пересечение по вертикали
    const verticalIntersection = Math.max(0,
        Math.min(elementRect.bottom, containerRect.bottom) -
        Math.max(elementRect.top, containerRect.top)
    );

    // Рассчитываем пересечение по горизонтали
    const horizontalIntersection = Math.max(0,
        Math.min(elementRect.right, containerRect.right) -
        Math.max(elementRect.left, containerRect.left)
    );

    // Если не учитываем частичную видимость - проверяем полную видимость
    if (!considerPartial) {
        return verticalIntersection >= elementRect.height &&
            horizontalIntersection >= elementRect.width;
    }

    // Рассчитываем процент видимости по вертикали и горизонтали
    const verticalVisiblePercent = (verticalIntersection / elementRect.height) * 100;
    const horizontalVisiblePercent = (horizontalIntersection / elementRect.width) * 100;

    // Элемент считается видимым если обе оси имеют достаточный процент видимости
    return verticalVisiblePercent >= minVisiblePercent &&
        horizontalVisiblePercent >= minVisiblePercent;

}